var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpingamesicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.604,
    height: 56.074,
    viewBox: "0 0 51.604 56.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(-2438.241 -1512.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M2480.574,1512.759h-33.062a9.282,9.282,0,0,0-9.271,9.271v37.532a9.282,9.282,0,0,0,9.271,9.271h33.063a9.28,9.28,0,0,0,9.271-9.271V1522.03A9.28,9.28,0,0,0,2480.574,1512.759Zm3.239,46.8a3.241,3.241,0,0,1-3.239,3.239h-3.016v-11.915a2.736,2.736,0,1,0-5.473,0V1562.8h-15.9v-8.061a2.737,2.737,0,0,0-5.475,0v8.061h-3.2a3.243,3.243,0,0,1-3.239-3.239V1522.03a3.243,3.243,0,0,1,3.239-3.239h33.063a3.241,3.241,0,0,1,3.239,3.239Z",
    fill: "#69a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M2457.191,1528.12a21.4,21.4,0,0,1-2.849-1.021,3.362,3.362,0,0,1-1.331-.977,2.213,2.213,0,0,1-.37-1.307,1.975,1.975,0,0,1,.862-1.673,4.025,4.025,0,0,1,2.417-.629,10.2,10.2,0,0,1,5.451,1.763l2.051-3a12.634,12.634,0,0,0-7.705-2.447,10.834,10.834,0,0,0-4.365.831,6.924,6.924,0,0,0-2.952,2.282,5.467,5.467,0,0,0-1.045,3.279,5.7,5.7,0,0,0,1.558,4.085,10.408,10.408,0,0,0,4.878,2.552,28.442,28.442,0,0,1,3.132,1.1,3.218,3.218,0,0,1,1.394,1.038,2.8,2.8,0,0,1,.39,1.574,2.343,2.343,0,0,1-1.046,2.031,4.8,4.8,0,0,1-2.807.734,9.685,9.685,0,0,1-5.9-2.129l-2.622,2.905a11.856,11.856,0,0,0,3.79,2.135,14.483,14.483,0,0,0,4.855.776,11.057,11.057,0,0,0,6.519-1.846,5.921,5.921,0,0,0,2.62-5.125,5.706,5.706,0,0,0-1.7-4.4A12.417,12.417,0,0,0,2457.191,1528.12Z",
    transform: "translate(8.177 6.13)",
    fill: "#69a8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M2452.847,1532.278a2.735,2.735,0,0,0-2.736,2.737v2.234a2.736,2.736,0,0,0,5.473,0v-2.234A2.735,2.735,0,0,0,2452.847,1532.278Z",
    transform: "translate(11.996 19.726)",
    fill: "#69a8ab"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpingamesicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/spin.games.icon.0c6650ddb230c925f5f0dfb6d10b4d92.svg";
export { ForwardRef as ReactComponent };